module.exports = __webpack_public_path__ + "static/media/revision.8b250f7f.svg";